import { render, staticRenderFns } from "./PanelKolInfo.vue?vue&type=template&id=46d3e8cd&scoped=true"
import script from "./PanelKolInfo.vue?vue&type=script&lang=js"
export * from "./PanelKolInfo.vue?vue&type=script&lang=js"
import style0 from "./PanelKolInfo.vue?vue&type=style&index=0&id=46d3e8cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d3e8cd",
  null
  
)

export default component.exports